import fetch from './fetch'

class InvestigateApi {
	public getList(form: any) {
		return fetch({
			url: 'injury/tasklist/survey/list',
			method: 'post',
			data: form,
		})
	}

	public addTask(form: any) {
		return fetch({
			url: 'injury/order/addSurvey',
			method: 'post',
			data: form,
		})
	}

	public exportOrder(params: any) {
		return fetch({
			url: 'injury/order/exportSurveyOrder',
			method: 'post',
			params,
		})
	}

	public exportList(form: any) {
		return fetch({
			url: 'injury/tasklist/survey/exportList',
			method: 'post',
			data: form,
			timeout: 0,
			responseType: 'blob',
		})
	}

	public batchExport(orderIds: any[]) {
		return fetch({
			url: 'injury/order/batchExportSurvey',
			method: 'post',
			data: {
				orderIds,
			},
			timeout: 0,
			responseType: 'blob',
		})
	}
}

export default new InvestigateApi()
